module.exports = __webpack_public_path__ + "static/img/595ba7b05f2e485eb50565a50cb6cc3c.90fd22fd.jpeg";